import React, { FC } from 'react';

import { TableCell, IconButton } from '@material-ui/core';
import cx from 'classnames';

import CircleMinusIcon from '../../../../../assets/icons/CircleMinusIcon';
import CirclePlusIcon from '../../../../../assets/icons/CirclePlusIcon';
import { colorsPalette } from '../../../../../theme';
import { CellProps } from '../../../const';

const ExpandCell: FC<CellProps> = ({ row, k, styles, align }) => {
  const toggleRow = row?.toggleRow ? row?.toggleRow : () => {};
  const loading = row?.loading || false;

  return (
    <TableCell key={k} className={cx(styles.contentCell, styles.iconCell)} align={align}>
      {loading ? (
        <div className={cx(styles.loadingCell)}>
          <div className={styles.cellLoaderContainer} />
        </div>
      ) : (
        <IconButton onClick={toggleRow}>
          {row[k] ? (
            <CircleMinusIcon className={styles.icon} color={colorsPalette.gray} />
          ) : (
            <CirclePlusIcon className={styles.icon} color={colorsPalette.gray} />
          )}
        </IconButton>
      )}
    </TableCell>
  );
};

export default ExpandCell;
